module.exports = __webpack_public_path__ + "706c89d1282a6d93cf3319c774edae99.svg";